/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    if(timestamp==null){
      return"";
    }
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};

/**
 * 根据时间秒
 * @param timestamp
 * @returns {*}
 */
const timehms = (timestamp) => {
  if(timestamp==0 || timestamp==null || timestamp==''){
    return "00:00";
  }
  let s=timestamp%60;
  if(s<10){
    s="0"+s;
  }
  let m=parseInt(timestamp/60);
  if(m<60){
    if(m<10){
      m="0"+m;
    }
    return m+":"+s;
  }
  let mm=m%60;
  if(mm<10){
    mm="0"+mm;
  }
  let h=parseInt(m/60);
  return h+":"+mm+":"+s;
}

/**
 * 根据时间秒
 * @param timestamp
 * @returns {*}
 */
const timehmZh = (timestamp) => {
  if(timestamp<60 || timestamp==null || timestamp==''){
    return "00时00分";
  }
  timestamp=parseInt(timestamp/60);
  if(timestamp<60){
    return "00时"+timestamp+"分";
  }
  let m=timestamp%60;
  let h=parseInt(timestamp/60);
  return h+"时"+m+"分";
}

/**
 * 时间戳
 * @param {*} timestampDate  时间戳
 */
export function timestampToDate(timestamp){
  if(timestamp==null){
    return null;
  }
  let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10 ?
      '0' + (date.getMonth() + 1) :
      date.getMonth() + 1) + '-'
  let D =
    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  return Y + M + D
};

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

const differenceDay = (beginTime, endTime) => {
  let dateBegin = new Date(beginTime);
  let dateEnd = new Date(endTime);
  let dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
  let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
  return dayDiff
 /* let leave1 = dateDiff % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000));//计算出小时数
  //计算相差分钟数
  let leave2 = leave1 % (3600 * 1000);   //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
  //计算相差秒数
  let leave3 = leave2 % (60 * 1000);     //计算分钟数后剩余的毫秒数
  let seconds = Math.round(leave3 / 1000);*/
}


const dateAddDays = (dataStr,dayCount) =>{
  var strdate = dataStr; // 2017年03月01日，该日期增加dayCount天
  strdate=strdate.replace("年","/");
  strdate=strdate.replace("月","/");
  strdate=strdate.replace("日","/");
  var isdate = new Date(strdate);
  isdate = new Date((isdate/1000+(86400*dayCount))*1000); // dayCount=1
  var year = isdate.getFullYear(); // yyyy
  var month = isdate.getMonth()+1; // M
  var day = isdate.getDate(); // d

  if (month >= 1 && month <= 9) { // MM
    month = "0" + month;
  }
  if (day >= 0 && day <= 9) { // dd
    day = "0" + day;
  }

  return timestampToTime(isdate);
}


/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

/**
 * 导出
 **/
export {
    timestampToTime,
    differenceDay,
    dateAddDays,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    timehms,
    timehmZh
}



// WEBPACK FOOTER //
// ./src/utils/util.js